var _defs, _title, _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMismatchedCourses(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 175,
    height: 179,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "_clipPath_xL2rsHB9OAmxx0Ka7XUi8uPcYAu2VNze"
  }, /*#__PURE__*/React.createElement("rect", {
    height: 179,
    id: "svg_1",
    width: 175
  })))), /*#__PURE__*/React.createElement("g", {
    className: "layer"
  }, _title || (_title = /*#__PURE__*/React.createElement("title", null, "Layer 1")), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    fill: "none",
    height: 179,
    id: "svgEditorBackground",
    width: 175,
    x: 0,
    y: 0
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#_clipPath_xL2rsHB9OAmxx0Ka7XUi8uPcYAu2VNze)",
    id: "svg_2"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "rgb(255,255,255)",
    height: 179,
    id: "svg_3",
    stroke: "rgb(209,209,209)",
    strokeMiterlimit: 10,
    transform: "matrix(1,0,0,1,0,0)",
    width: 175,
    x: 0,
    y: 0.57
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("mask", {
    id: "_mask_BoUnb9xcw2LMwm9Re0zQYlaja8wlMGr3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m11.5,51.06l152,0l0,106l-152,0l0,-106z",
    fill: "white",
    id: "svg_4",
    stroke: "black",
    strokeMiterlimit: 10
  })), /*#__PURE__*/React.createElement("mask", {
    id: "_mask_iqVKvL0RooZnb2xZiwF4BVq9TiD2qM94"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m11.5,51.06l152,0l0,106l-152,0l0,-106z",
    fill: "white",
    id: "svg_5",
    stroke: "black",
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    id: "svg_6",
    mask: "url(#_mask_iqVKvL0RooZnb2xZiwF4BVq9TiD2qM94)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svg_7",
    mask: "url(#_mask_BoUnb9xcw2LMwm9Re0zQYlaja8wlMGr3)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "svg_8",
    mask: "url(#_mask_BoUnb9xcw2LMwm9Re0zQYlaja8wlMGr3)"
  }, /*#__PURE__*/React.createElement("image", {
    height: 106,
    id: "svg_9",
    transform: "matrix(1,0,0,1,11.5,51.062)",
    width: 152,
    xlinkHref: "data:image/png;svgedit_url=data%3Aimage%2Fpng%3Bbase64%2CiVBORw0KGgoAAAANSUhEUgAAAJgAAABqCAYAAABAmJgzAAACaklEQVR4Xu3awQ0CMRQDUdJUykZCFMhK9DAnPwqI5fFc%2Fopz7%2F29%2FBCICByCRWQ9%2BydAMCKkBAiW4vU4wTiQEiBYitfjBONASoBgKV6PE4wDKQGCpXg9TjAOpARO%2BrrH5wkQbF6BFgDBWr7zrxNsXoEWAMFavvOvE2xegRbAeX%2B%2B%2FnDYMp5%2BnWDT8%2FflCdYznk4g2PT8fXmC9YynE1yR0%2FP35QnWM55OINj0%2FH15gvWMpxMINj1%2FX55gPePpBJ8ppufvyxOsZzydQLDp%2BfvyBOsZTycQbHr%2Bvrwrsmc8nUCw6fn78gTrGU8nEGx6%2Fr48wXrG0wmuyOn5%2B%2FIE6xlPJxBsev6%2BPMF6xtMJBJuevy%2FviuwZTycQbHr%2BvjzBesbTCQSbnr8vT7Ce8XQCwabn78v7TNEznk4g2PT8fXmC9YynEwg2PX9fnmA94%2BkEV%2BT0%2FH15gvWMpxMINj1%2FX55gPePpBIJNz9%2BXd0X2jKcTCDY9f1%2BeYD3j6QSCTc%2FflydYz3g6wRU5PX9fnmA94%2BkEgk3P35cnWM94OoFg0%2FP35QnWM55O8Jliev6%2BPMF6xtMJBJuevy9PsJ7xdALBpufvy7sie8bTCQSbnr8vT7Ce8XQCwabn78sTrGc8neCKnJ6%2FL0%2BwnvF0AsGm5%2B%2FLE6xnPJ1AsOn5%2B%2FKuyJ7xdALBpufvyxOsZzydQLDp%2BfvyBOsZTycQbHr%2BvrzPFD3j6QSCTc%2FflydYz3g6gWDT8%2FflCdYznk5wRU7P35cnWM94OoFg0%2FP35QnWM55OINj0%2FH15V2TPeDqBYNPz9%2BUJ1jOeTiDY9Px9eYL1jKcTHlZCnFOSXvuAAAAAAElFTkSuQmCC;base64,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"
  })), /*#__PURE__*/React.createElement("rect", {
    fill: "rgb(255,255,255)",
    height: 106,
    id: "svg_10",
    transform: "matrix(1,0,0,1,0,0)",
    width: 12.6,
    x: 69.4,
    y: 51.06
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "rgb(255,255,255)",
    height: 106,
    id: "svg_11",
    transform: "matrix(1,0,0,1,0,0)",
    width: 12.6,
    x: 69.4,
    y: 51.06
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "rgb(235,235,235)",
    height: 89.06,
    id: "svg_12",
    transform: "matrix(1,0,0,1,0,0)",
    width: 7.4,
    x: 62,
    y: 68
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    fill: "rgb(255,200,0)",
    id: "svg_13",
    r: 1,
    transform: "matrix(2.5,0,0,2.5,66.2,70.5)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    fill: "rgb(255,200,0)",
    id: "svg_14",
    r: 1,
    transform: "matrix(2.5,0,0,2.5,66.2,81.5)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    fill: "rgb(255,200,0)",
    id: "svg_15",
    r: 1,
    transform: "matrix(2.5,0,0,2.5,66.2,91.5)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    fill: "rgb(255,200,0)",
    id: "svg_16",
    r: 1,
    transform: "matrix(2.5,0,0,2.5,66.2,102.5)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    fill: "rgb(255,200,0)",
    id: "svg_17",
    r: 1,
    transform: "matrix(2.5,0,0,2.5,66.2,112.5)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    fill: "rgb(255,200,0)",
    id: "svg_18",
    r: 1,
    transform: "matrix(2.5,0,0,2.5,66.2,123.5)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    fill: "rgb(255,200,0)",
    id: "svg_19",
    r: 1,
    transform: "matrix(2.5,0,0,2.5,66.2,133.5)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    fill: "rgb(255,200,0)",
    id: "svg_20",
    r: 1,
    transform: "matrix(2.5,0,0,2.5,66.2,144.5)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    fill: "rgb(255,200,0)",
    id: "svg_21",
    r: 1,
    transform: "matrix(2.5,0,0,2.5,66.2,154.5)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    fill: "rgb(255,200,0)",
    id: "svg_22",
    r: 1,
    transform: "matrix(2.5,0,0,2.5,66.2,70.5)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "svg_23",
    transform: "matrix(1,0,0,1,31,10)"
  }))), /*#__PURE__*/React.createElement("text", {
    fill: "black",
    fontFamily: "\"Trebuchet MS\"",
    fontSize: "13.34px",
    fontWeight: "bold",
    id: "e1_texte",
    style: {
      cursor: "move"
    },
    transform: "rotate(-0.052306 86.656 18.16)",
    x: 23.46,
    y: 23.16
  }, "Mismatched Courses")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMismatchedCourses);
export default __webpack_public_path__ + "static/media/mismatchedCourses.8f6715dbc368bc6aa93e797f858d71de.svg";
export { ForwardRef as ReactComponent };